import logoVAF from '../../../assets/logo-abogados-vaf.jpeg';
import logoAH from '../../../assets/logo-abogados-ah.png';
import jsPDF from 'jspdf';
import html2pdf from 'html2pdf.js';
import { templateData, investigationTypes } from './../case-data';
import { Link, useParams } from 'react-router-dom';
import { getCase } from './../../../actions/case-actions';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Swal from 'sweetalert2';
import { getDocumentData } from '../../../actions/documents-actions';

function LegalityTemplate(){
    const currentLink = "/casos";
    const dispatch = useDispatch();
    const [loadData, setLoadData] = useState(true);
    const params = useParams();
    const user = useSelector(state => state.user.user);
    const [currentData, setCurrentData] = useState({});

    useEffect(() => {
        if (loadData) {
            const getFunction = (data) => {
                if(data.code === "01"){
                    Swal.fire({
                        title:"Error",
                        confirmButtonColor:"#76b4ff",
                        text: data.message
                    });
                }else{
                    //console.log('datos', data.data);
                    
                    let clientPosition = `${data.data.case.statePosition === 'ex'?'ex':''} ${data.data.case.position}`;
                    data.data.clientText = `${data.data.client.clientId.firstName} ${data.data.client.clientId.lastName} ${data.data.client.clientId.documentType}: ${data.data.client.clientId.document} - ${clientPosition}`.toLocaleUpperCase();
                    data.data.entityText = `${data.data.case.territorialEntity} - ${data.data.case.executionCity} ${data.data.case.executionProvince}`.toLocaleUpperCase();
                    data.data.companyText = `${data.data.company.companyId.description} - ${data.data.company.companyId.city} ${data.data.company.companyId.province}`.toLocaleUpperCase();
                    data.data.companyText = `${data.data.company.companyId.description} - ${data.data.company.companyId.city} ${data.data.company.companyId.province}`.toLocaleUpperCase();
                    data.data.legalityControl.typeText = `${data.data.legalityControl.type === 'autoOpening'?'AUTO DE APERTURA':'IMPUTACIÓN'}`;
                    data.data.clientText = `${data.data.clientText} ${data.data.legalityControl.investigatedCorrect?' - CORRECTO':` - INCORRECTO: ${data.data.legalityControl.investigatedObservation}`}`;
                    data.data.reviewedUserText = `${data.data.legalityControl.reviewedUser.firstName} ${data.data.legalityControl.reviewedUser.lastName}`.toLocaleUpperCase();

                    for (let index = 0; index < investigationTypes.length; index++) {
                        if (data.data.caseType === investigationTypes[index].value) {
                            data.data.caseType = investigationTypes[index].name.toLocaleUpperCase()
                        }
                    }

                    setCurrentData( data.data );
                }
            }

            setLoadData(false);

            dispatch( getCase( params.id, getFunction, user.token ) );
        }
    }, [loadData, dispatch, params.id, user.token ]);

    const downloadFile = () => {
        let doc = new jsPDF('p', 'pt', 'a4');
        const element = document.querySelector("#capture");
        const marginX = 20;
        const opt = {
            margin: [38, marginX, 23, marginX],
            filename: `CONTROL LEGALIDAD EXP ${currentData.filingNumber.toUpperCase()}.pdf`,
            enableLinks: false,
            pagebreak: {
              avoid: ['tr'],
              mode: ['css', 'avoid-all'],
            },
            image: { type: 'jpeg', quality: 0.7 },
            html2canvas: {
              allowTaint: true,
              dpi: 300,
              letterRendering: true,
              logging: false,
              scale: 2,
              scrollX: 0,
              scrollY: 0,
            },
            jsPDF: { doc },
          };

        html2pdf()
        .from(element)
        .set(opt)
        .toPdf()
        .get('pdf')
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .then((pdf) => {
            const totalPages = pdf.internal.getNumberOfPages();
            for (let i = 1; i < totalPages + 1; i++) {
                pdf.setPage(i);
                pdf.setFontSize(7);

                let heightSpace = pdf.internal.pageSize.getHeight() - 12;
                let logo = currentData.legalCompany === 'VAF'? logoVAF:logoAH;
                const sizeX = currentData.legalCompany === 'VAF'? 38:33;
                const sizeY = currentData.legalCompany === 'VAF'? 20:23;
                let posX = pdf.internal.pageSize.getWidth()-(marginX+sizeX);
                // Validación de espacio porque el logo tiene márgenes
                posX = currentData.legalCompany === 'VAF'?(posX+4):posX;
                const posY = 10;

                // addImage(img, posX, posY, sizeX, sizeY) => posX = marginX+sizeX
                pdf.addImage(logo, posX, posY, sizeX, sizeY);

                Object.keys(templateData.company).map((keyName, i) => {
                    pdf.text(
                        `${templateData.company[keyName]}`,
                        (pdf.internal.pageSize.getWidth()/2)-(templateData.company[keyName].length/2),
                        heightSpace,
                    );
                    heightSpace += 3;
                    return i;
                })
                const pages = `${i}/${totalPages}`;
                pdf.text(
                    pages,
                    (pdf.internal.pageSize.getWidth()/2)-(pages.length/2),
                    heightSpace,
                );
            }
        })
        .save();
    }

    return (
        <div className="w-100 d-flex">
            <div className="container d-flex flex-column">
                <div className="w-100 mt-5">
                    <Link to={currentLink + `/editar/${params.id}`} key={params.id} className="back-button">&#60; Volver</Link>
                </div>
                <h1 className="my-5">Control de legalidad</h1>
                <div className="d-flex flex-column p-4 template-container document-container">
                    <img src={currentData.legalCompany === 'VAF'? logoVAF:logoAH} alt="Logo" className="lawer-logo" />
                    { currentData._id ? 
                        getDocumentData('legality', currentData)
                    : ''}
                    <div className="d-flex justify-content-center w-100 info-span-container">
                        <div className="d-flex flex-column">
                            {Object.keys(templateData.company).map((keyName, i) => (
                                <span key={i} className="info-span">{templateData.company[keyName]}</span>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="d-flex justify-content-center w-100 my-2">
                    <button onClick={downloadFile} className="btn btn-primary">Descargar</button>
                </div>
            </div>
        </div>
    );
}
 
export default LegalityTemplate;